import React, { useEffect, useState } from "react";
import { motion } from "framer-motion";
import { Outlet } from "react-router-dom";
import { Orientation } from "../../../logic/enums.ts";

const RaindropBase = ({ orientation }) => {
  let maxWidth = "max-w-[500px]";

  if (orientation === Orientation.Landscape) {
    maxWidth = "w-[100dvw]";
  }

  // Theme - START
  const [theme, setTheme] = useState(
    window.matchMedia("(prefers-color-scheme: dark)").matches ? "dark" : "light"
  );

  useEffect(() => {
    const mediaQuery = window.matchMedia("(prefers-color-scheme: dark)");
    const handleChange = () => {
      setTheme(mediaQuery.matches ? "dark" : "light");
    };

    mediaQuery.addEventListener("change", handleChange);

    // Cleanup function:
    return () => mediaQuery.removeEventListener("change", handleChange);
  }, []);
  // Theme - END

  return (
    <div className={`${theme}`}>
      <div
        id={"raindrop-app"}
        className={
          "flex flex-col  w-full h-[100dvh] justify-center items-center  select-none content-center dark:text-color-dark-text-primary  dark:bg-color-dark-background-primary bg-color-background-primary fixed"
        }
      >
        <motion.div
          key={"raindrop-app"}
          className={`flex flex-col ${maxWidth} w-full h-full  `}
        >
          <Outlet />
        </motion.div>
      </div>
    </div>
  );
};

export default RaindropBase;
